/**
* Main class load in index file
*/
import AnalyticsConnectorPublic from './analyticsConnectorPublic';
import AnalyticsConnector from "./analyticsConnector";


import ConsoleManager from "./consoleManager";
window.networkOnProcess = true;
window.checkBeaconNetworkStatus = true;
window.SPN_Console = new ConsoleManager();
window.ANALYTICS_CONNECTOR = AnalyticsConnector;
window.ANALYTICS_CONNECTOR_FRONTEND = new window.ANALYTICS_CONNECTOR({ sender: 'self' });
window.godavariAnalyticsSessionData = {};
window.godavariAnalyticsAdsSessionData = {};
window.beaconExecutionState = true;

if (typeof window.ANALYTICS_SDK_LOADED == 'function') {
    window.ANALYTICS_SDK_LOADED();
}

try {
    if(!localStorage.getItem("ANALYTICS_ALL_ERROR_DATA")){ 
        localStorage.setItem("ANALYTICS_ALL_ERROR_DATA",JSON.stringify({}));
    }
    if(!localStorage.getItem("ANALYTICS_ALL_END_DATA")){
        localStorage.setItem("ANALYTICS_ALL_END_DATA",JSON.stringify({}));
    }    
} catch (error) {}


// window.spnAnalyticsDefaultData = {
//     userId: "",
//     deviceId: "",
//     subscribeType: "",
//     partnerId: "",
//     appVersion: "",
//     geoLocation: "",
//     platform: "",
//     eighteen_plus: ""
// };

window.analyticsSDKInfo = {
    analyticsSDKVersion: ANALYTICS_SDK_VERSION,
    branch: BRANCH,
    commitHash: COMMITHASH,
    analyticsBuild: ANALYTICS_SDK_BUILD,
    analyticsName: "",
    analyticsLibVersion: ""
};


